module.exports = __webpack_public_path__ + "img/8-m.fc258f75.jpg";